import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { NutritionInfoPage } from 'pages/nutrition-info-page/nutrition-info-page';

@NgModule({
  declarations: [NutritionInfoPage],
  imports: [PagesModule, ComponentsModule],
  exports: [NutritionInfoPage]
})
export class NutritionInfoPageModule { }
